import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Wrapper } from './styles';
import { ReactComponent as InfoIcon } from 'applicaiton/assets/info.svg';
import PrimaryButton from '../PrimaryButton';
import { useNavigate } from 'react-router-dom';
import { PathNames } from 'applicaiton/routes';

const SubscriptionsExpiredSoon: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(PathNames.clinicBilling);
  };

  return (
    <Wrapper>
      <div>
        <InfoIcon />
        <p>
          {t('subscription_warnings.warning_text_1')}
          <span>{t('subscription_warnings.warning_text_2')}</span>
          {t('subscription_warnings.warning_text_3')}
        </p>
      </div>
      <PrimaryButton styleType={'error'} type={'button'} onClick={handleClick}>
        {t('subscription_warnings.go_to_settings')}
      </PrimaryButton>
    </Wrapper>
  );
};

export default SubscriptionsExpiredSoon;
